import styled from "styled-components";

type ContainerProps = {
    maxWidth?: string;
    noPadding?: boolean;
}

type TabContainerProps = {
    maxWidth?: string;
}

export const Container = styled.div<ContainerProps>`
    width: 100%;
    max-width: ${props => props.maxWidth || '100%'};
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: auto;
    gap: 40px;
    padding: 96px 64px;

   ${ props => props.noPadding && `
        padding: 0px;
   `}

    @media ${(props) =>
      props.theme.breakpoints && props.theme.breakpoints.md} {
     padding: 64px 32px 48px 32px;
     gap: 32px;

     ${props => props.noPadding && `
        padding: 0px;
     `}
    }


    @media ${(props) =>
      props.theme.breakpoints && props.theme.breakpoints.sm} {
     padding: 48px 24px 32px 24px;
     gap: 24px;

     ${props => props.noPadding && `
        padding: 0px;
     `}
  }
`;

export const TabContainer = styled.div<TabContainerProps>`
    width: 100%;
    max-width: ${props => props.maxWidth || '100%'};
    position: relative;
    display: grid;
    grid-template-columns: repeat(auto-fit,minmax(400px,auto));
    grid-gap: 30px 32px; 
    margin: auto;


  @media ${(props) =>
      props.theme.breakpoints && props.theme.breakpoints.md} {
     grid-template-columns: 1fr;
  }
`;

export const Title = styled.h1`
    color: #FFF;
    text-align: center;

    text-shadow: 0px 1px 3px rgba(16, 24, 40, 0.10), 0px 1px 2px rgba(16, 24, 40, 0.06);
    font-family: everettregular;
    font-size: 48px;
    font-style: normal;
    font-weight: 500;
    line-height: 64px;
    letter-spacing: -0.8px;

    @media ${(props) =>
      props.theme.breakpoints && props.theme.breakpoints.md} {
     font-size: 32px;
     line-height: 40px;
  }
`;